import Model, { attr, hasMany } from '@ember-data/model';

export default class User extends Model {
  @attr('string') fullName;
  @attr('string') email;
  @hasMany('location-role', { async: false, inverse: null }) locationRoles;
}
